import { type Subscription } from '@air/api/types';

/** Every fixed-model plan uses the fixed-plan usage layout, legacy Creator, Plus, Pro and Business v1 included. */
export const shouldUseFixedPlanUsageLayout = (subscription: Pick<Subscription, 'pricingModel'> | undefined) =>
  subscription?.pricingModel === 'fixed';
